// extracted by mini-css-extract-plugin
export default {"container":"Separator_container__Lhg07","text":"Separator_text__MuRLz","line":"Separator_line__Og21v"};